import { render } from "./CompanySectionList.vue?vue&type=template&id=6a92d35f"
import script from "./CompanySectionList.vue?vue&type=script&lang=js"
export * from "./CompanySectionList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__